import React from "react";
import Header from "../components/FrontPage/Header/Header";
import Footer from "../components/Footer/Footer";
import LeftDrawer from "../components/Dashboard/Drawers/LeftDrawer";
import Factoring from "./static/Factoring";
import ScrollToTopOnMount from "../helpers/ScrollToTop";

const FactoringPage = ({ USER }) => {
  return (
    <>
      <ScrollToTopOnMount />
      <Header />
      <Factoring />
      <Footer />
      {USER && <LeftDrawer small />}
    </>
  );
};

export default FactoringPage;
